import { TableCellType } from "src/modules/sm-base/models/table-cell-type.enum";

export class FrontendWorkflowInboxColumnDefinition {
    id: string;
    title: string;
    source: string;
    type: TableCellType;
}
